import { render, staticRenderFns } from "./RepairDetails.vue?vue&type=template&id=2b5b1987&"
import script from "./RepairDetails.vue?vue&type=script&lang=js&"
export * from "./RepairDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports